import React, { Component } from "react";
import routes from "./common/routes/routes";
import Routing from "./../utilities/routing";
import PrivateRoutes from "./common/routes/PrivateRoutes";
// import NavbarComponent from './common/navbar/NavbarComponent';
import NotFoundComponent from "./common/NotFoundComponent";
import { connect } from "react-redux";
import * as actions from './../actions'
// import Loading from './common/loaders/Loading';
import "../App.css";
import logo from "../components/common/navbar/Toolbar/tradesmen_new.png";
import { Row, Col } from "reactstrap";

import Toolbar from './Toolbar/Toolbar'

const withRouter = Routing.withRouter;
const Switch = Routing.Switch;
const Route = Routing.Route;

class MainComponent extends Component {
  async  componentDidMount() {
    localStorage.setItem('localVar','false');
    await this.props.authUser();
  //  this.props.history.push(`/11111`)
  }
  render() {
    const {keycloak, authenticated} = this.props;
    if(!keycloak && !authenticated){
      return null
      // <Loading/>
    }
    return (
      <div className="container-fluid container-background supervisor-main">

      {/* <Toolbar/> */}
        <Switch>
          {routes.map((route, i) => {
            return <PrivateRoutes key={i} {...route} {...this.props} />;
          })}
          <Route component={NotFoundComponent} />
        </Switch>
      </div>
    );
  }
}
const mapStateToProps =(state)=>{
  console.log("state",state)
    return{
      keycloak: state.authInfo.keycloak,
      authenticated: state.authInfo.authenticated,
      // userRole:state.authInfo.corporateEmployee,
      // alerts : state.alerts,
      // employeeID : state.authInfo,
     }
}
export default withRouter(connect(mapStateToProps, actions)(MainComponent));
